import React from 'react';
import { get } from 'lodash-es';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

const numbersOnlyText = '(numbers only, no decimals or symbols)';

const LotRealizedForm = ({
  handleInputChange,
  isEditing = false,
  lotData: {
    lotNumber,
    lotExt,
    realizedPrice,
  },
  validateFields,
  validation
}) => {
  let lotNumberClass = '';
  let lotExtClass = '';
  let RealizedPriceClass = '';
  if (isEditing) {
    lotNumberClass = 'cursor-not-allowed';
    lotExtClass = 'cursor-not-allowed';
    RealizedPriceClass = 'cursor-not-allowed';
  } else if (get(validation, 'lotNumber')) {
    lotNumberClass = 'is-invalid';
  }

  return (
    <Form>
      <Row>
        {/* Start Left Column */}
        <Col xs={12}>
          <h3>Item Details</h3>
          <FormGroup>
            <Label for="lotNumber">Item Number*</Label>
            <Input
              id="lotNumber"
              className={lotNumberClass}
              disabled={isEditing}
              name="lotNumber"
              onBlur={() => validateFields('lotNumber')}
              onChange={e => handleInputChange(e)}
              value={lotNumber}
            />
            {get(validation, 'lotNumber') && (
            <p className="color-danger my-0">{get(validation, 'lotNumber')}</p>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="lotExt">Item Extension</Label>
            <Input
              id="lotExt"
              className={lotExtClass}
              disabled={isEditing}
              name="lotExt"
              onBlur={() => validateFields('lotExt')}
              onChange={e => handleInputChange(e)}
              value={lotExt}
            />
            {get(validation, 'lotExt') && (
            <p className="color-danger my-0">{get(validation, 'lotExt')}</p>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="realizedPrice">Realized Price</Label> {numbersOnlyText}
            <Input
              id="realizedPrice"
              className={RealizedPriceClass}
              name="realizedPrice"
              onBlur={() => validateFields('realizedPrice')}
              onChange={e => handleInputChange(e)}
              value={realizedPrice}
            />
            {get(validation, 'realizedPrice') && (
            <p className="color-danger my-0">{get(validation, 'realizedPrice')}</p>
            )}
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default LotRealizedForm;
